/**
 * Label for the mobile filter sheet's "Show N results" footer button.
 */
export function formatResultsCountLabel(totalCount) {
  if (totalCount == null) return "Show results";
  // totalCount can arrive as a string off a MySQL-backed count query - coerce
  // before the strict === check below, or "1" reads as plural ("Show 1
  // results").
  const n = Number(totalCount);
  return `Show ${totalCount} ${n === 1 ? "result" : "results"}`;
}
